import { jsx as _jsx } from "react/jsx-runtime";
export const FigmaEmbed = ({ originalUrl }) => {
    const iframeUrl = new URL(originalUrl);
    const nodeId = iframeUrl.searchParams.get('node-id');
    const searchParameters = new URLSearchParams({
        'embed-host': 'contra.com',
        footer: 'false',
        theme: 'light',
        'viewport-controls': 'false',
    });
    if (nodeId) {
        searchParameters.set('node-id', nodeId);
    }
    iframeUrl.host = 'embed.figma.com';
    iframeUrl.search = searchParameters.toString();
    return (_jsx("iframe", { loading: "lazy", src: iframeUrl.toString(), style: {
            border: 'none',
            borderRadius: 6,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
            height: 500,
            width: '100%',
        } }));
};
//# sourceMappingURL=FigmaEmbed.js.map